"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addParamToUrl = void 0;
const query_string_1 = require("query-string");
/**
 * 任意のURLにパラメータを追加する
 * @param url
 * @param param
 *
 * https://google.com → https://google.com?foo=bar
 * https://google.com?ref=hoge → https://google.com?ref=hoge&foo=bar
 */
const addParamToUrl = (original, params) => {
    const { url, query } = (0, query_string_1.parseUrl)(original);
    return (0, query_string_1.stringifyUrl)({ url, query: Object.assign(params, query) });
};
exports.addParamToUrl = addParamToUrl;
//# sourceMappingURL=addParamToUrl.js.map